/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import classnames from "classnames";
import styles from "./IconOverlay.module.scss";

interface Props {
    className?: string;
    mode: "success" | "in_progress" | "error";
    children: React.ReactNode;
}

const IconOverlay: React.FC<Props> = ({mode, children, className}) => {

    const iconModeClassName = React.useMemo(() => {
        switch (mode) {
            case "success":
                return styles.iconContainerSuccess;
            case "in_progress":
                return styles.iconContainerInProgress;
            case "error":
                return styles.iconContainerError;
        }
    }, [mode])

    return (
        <div className={classnames(styles.iconContainer, iconModeClassName, className)}>
            {children}
        </div>);
}

export default IconOverlay;
